/* GET LEADS */
export const GET_LEADS = "GET_LEADS"
export const GET_LEADS_SUCCESS = "GET_LEADS_SUCCESS"
export const GET_LEADS_ERROR = "GET_LEADS_ERROR"

export const UPDATE_LEAD = "UPDATE_LEADS"
export const UPDATE_LEAD_SUCCESS = "UPDATE_LEADS_SUCCESS"
export const UPDATE_LEAD_ERROR = "UPDATE_LEADS_ERROR"

export const GET_LEAD_BY_ID = "GET_LEAD_BY_ID"
export const GET_LEAD_BY_ID_SUCCESS = "GET_LEAD_BY_ID_SUCCESS"
export const GET_LEAD_BY_ID_ERROR = "GET_LEAD_BY_ID_ERROR"

export const GET_LEAD_BY_QUOTE_CALL_ID = "GET_LEAD_BY_QUOTE_CALL_ID"
export const GET_LEAD_BY_QUOTE_CALL_ID_SUCCESS = "GET_LEAD_BY_QUOTE_CALL_ID_SUCCESS"
export const GET_LEAD_BY_QUOTE_CALL_ID_ERROR = "GET_LEAD_BY_QUOTE_CALL_ID_ERROR"

export const UPDATE_LEAD_DETAILS = "UPDATE_LEAD_DETAILS"
export const UPDATE_LEAD_DETAILS_SUCCESS = "UPDATE_LEAD_DETAILS_SUCCESS"
export const UPDATE_LEAD_DETAILS_ERROR = "UPDATE_LEAD_DETAILS_ERROR"


export const ADD_LEAD_VEHICLE = "ADD_LEAD_VEHICLE"
export const ADD_LEAD_VEHICLE_SUCCESS = "ADD_LEAD_VEHICLE_SUCCESS"
export const ADD_LEAD_VEHICLE_ERROR = "ADD_LEAD_VEHICLE_ERROR"


export const UPDATE_LEAD_VEHICLE = "UPDATE_LEAD_VEHICLE"
export const UPDATE_LEAD_VEHICLE_SUCCESS = "UPDATE_LEAD_VEHICLE_SUCCESS"
export const UPDATE_LEAD_VEHICLE_ERROR = "UPDATE_LEAD_VEHICLE_ERROR"


export const DELETE_LEAD_VEHICLE = "DELETE_LEAD_VEHICLE"
export const DELETE_LEAD_VEHICLE_SUCCESS = "DELETE_LEAD_VEHICLE_SUCCESS"
export const DELETE_LEAD_VEHICLE_ERROR = "DELETE_LEAD_VEHICLE_ERROR"


export const ADD_LEAD_HOME = "ADD_LEAD_HOME"
export const ADD_LEAD_HOME_SUCCESS = "ADD_LEAD_HOME_SUCCESS"
export const ADD_LEAD_HOME_ERROR = "ADD_LEAD_HOME_ERROR"

export const UPDATE_LEAD_HOME = "UPDATE_LEAD_HOME"
export const UPDATE_LEAD_HOME_SUCCESS = "UPDATE_LEAD_HOME_SUCCESS"
export const UPDATE_LEAD_HOME_ERROR = "UPDATE_LEAD_HOME_ERROR"

export const DELETE_LEAD_HOME = "DELETE_LEAD_HOME"
export const DELETE_LEAD_HOME_SUCCESS = "DELETE_LEAD_HOME_SUCCESS"
export const DELETE_LEAD_HOME_ERROR = "DELETE_LEAD_HOME_ERROR"

export const ADD_LEAD_BUSINESS_ENTITY = "ADD_LEAD_BUSINESS_ENTITY"
export const ADD_LEAD_BUSINESS_ENTITY_SUCCESS = "ADD_LEAD_BUSINESS_ENTITY_SUCCESS"
export const ADD_LEAD_BUSINESS_ENTITY_ERROR = "ADD_LEAD_BUSINESS_ENTITY_ERROR"

export const UPDATE_LEAD_BUSINESS_ENTITY = "UPDATE_LEAD_BUSINESS_ENTITY"
export const UPDATE_LEAD_BUSINESS_ENTITY_SUCCESS = "UPDATE_LEAD_BUSINESS_ENTITY_SUCCESS"
export const UPDATE_LEAD_BUSINESS_ENTITY_ERROR = "UPDATE_LEAD_BUSINESS_ENTITY_ERROR"

export const DELETE_LEAD_BUSINESS_ENTITY = "DELETE_LEAD_BUSINESS_ENTITY"
export const DELETE_LEAD_BUSINESS_ENTITY_SUCCESS = "DELETE_LEAD_BUSINESS_ENTITY_SUCCESS"
export const DELETE_LEAD_BUSINESS_ENTITY_ERROR = "DELETE_LEAD_BUSINESS_ENTITY_ERROR"

export const ADD_LEAD_VIOLATION = "ADD_LEAD_VIOLATION"
export const ADD_LEAD_VIOLATION_SUCCESS = "ADD_LEAD_VIOLATION_SUCCESS"
export const ADD_LEAD_VIOLATION_ERROR = "ADD_LEAD_VIOLATION_ERROR"

export const UPDATE_LEAD_VIOLATION = "UPDATE_LEAD_VIOLATION"
export const UPDATE_LEAD_VIOLATION_SUCCESS = "UPDATE_LEAD_VIOLATION_SUCCESS"
export const UPDATE_LEAD_VIOLATION_ERROR = "UPDATE_LEAD_VIOLATION_ERROR"

export const DELETE_LEAD_VIOLATION = "DELETE_LEAD_VIOLATION"
export const DELETE_LEAD_VIOLATION_SUCCESS = "DELETE_LEAD_VIOLATION_SUCCESS"
export const DELETE_LEAD_VIOLATION_ERROR = "DELETE_LEAD_VIOLATION_ERROR"

export const ADD_LEAD_REFUND = "ADD_LEAD_REFUND"
export const ADD_LEAD_REFUND_SUCCESS = "ADD_LEAD_REFUND_SUCCESS"
export const ADD_LEAD_REFUND_ERROR = "ADD_LEAD_REFUND_ERROR"

export const UPDATE_LEAD_REFUND = "UPDATE_LEAD_REFUND"
export const UPDATE_LEAD_REFUND_SUCCESS = "UPDATE_LEAD_REFUND_SUCCESS"
export const UPDATE_LEAD_REFUND_ERROR = "UPDATE_LEAD_REFUND_ERROR"

export const DELETE_LEAD_REFUND = "DELETE_LEAD_REFUND"
export const DELETE_LEAD_REFUND_SUCCESS = "DELETE_LEAD_REFUND_SUCCESS"
export const DELETE_LEAD_REFUND_ERROR = "DELETE_LEAD_REFUND_ERROR"

export const ADD_LEAD_APPLICANT = "ADD_LEAD_APPLICANT"
export const ADD_LEAD_APPLICANT_SUCCESS = "ADD_LEAD_APPLICANT_SUCCESS"
export const ADD_LEAD_APPLICANT_ERROR = "ADD_LEAD_APPLICANT_ERROR"

export const UPDATE_LEAD_APPLICANT = "UPDATE_LEAD_APPLICANT"
export const UPDATE_LEAD_APPLICANT_SUCCESS = "UPDATE_LEAD_APPLICANT_SUCCESS"
export const UPDATE_LEAD_APPLICANT_ERROR = "UPDATE_LEAD_APPLICANT_ERROR"

export const DELETE_LEAD_APPLICANT = "DELETE_LEAD_APPLICANT"
export const DELETE_LEAD_APPLICANT_SUCCESS = "DELETE_LEAD_APPLICANT_SUCCESS"
export const DELETE_LEAD_APPLICANT_ERROR = "DELETE_LEAD_APPLICANT_ERROR"

export const GET_LEAD_REFUND_REASONS = "GET_LEAD_REFUND_REASONS"
export const GET_LEAD_REFUND_REASONS_SUCCESS = "GET_LEAD_REFUND_REASONS_SUCCESS"
export const GET_LEAD_REFUND_REASONS_ERROR = "GET_LEAD_REFUND_REASONS_ERROR"

export const GET_LEAD_DETAILS_EXPORT = "GET_LEAD_DETAILS_EXPORT"
export const GET_LEAD_DETAILS_EXPORT_SUCCESS = "GET_LEAD_DETAILS_EXPORT_SUCCESS"
export const GET_LEAD_DETAILS_EXPORT_ERROR = "GET_LEAD_DETAILS_EXPORT_ERROR"